<template>
  <div>
    <div class="license-plate-box">
      <div class="country-code">
        <icon icon="license-plate-dutch-country-code" color="#ffca00" />
      </div>
      <input
        id="license-plate-input"
        ref="licensePlate"
        v-model="v$.licensePlateCopy.$model"
        type="text"
        maxlength="8"
        data-qa="extras-exchange-car-license-plate"
        data-action="enter-exchange-car-license-plate"
        :readonly="readOnly"
        @input="processPlate"
      />
    </div>
    <template v-if="v$.licensePlateCopy.$anyDirty && v$.licensePlateCopy.validLicensePlateLength">
      <template v-if="!v$.licensePlateCopy.validLicensePlateFormat">
        Ongeldig kentekenformaat
      </template>
    </template>
  </div>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { required, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

import { getLicensePlateFormat, addSeparators } from '@/helpers/LicensePlateFormats'

const validLicensePlateLength = (value) => {
  if (value < 6) return false

  value = value.replace(/-/g, '')
  return value.length >= 6
}

const validLicensePlateFormat = (value) => {
  if (!helpers.req(value)) return false

  const licensePlateFormat = getLicensePlateFormat(value)
  return !!licensePlateFormat
}

export default {
  components: {
    Icon,
  },
  props: {
    licensePlate: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['updateLicensePlate'],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      licensePlateCopy: '',
      showError: false,
    }
  },

  watch: {
    licensePlate(value) {
      this.licensePlateCopy = value
    },
  },

  created() {
    this.licensePlateCopy = this.licensePlate
  },
  validations: {
    licensePlateCopy: {
      required,
      validLicensePlateFormat,
      validLicensePlateLength,
    },
  },
  methods: {
    replaceSpaceByHyphens(value) {
      return value.replace(/ /g, '-')
    },
    clearHyphens(value) {
      return value.replace(/-/g, '')
    },
    processPlate() {
      this.licensePlateCopy = this.replaceSpaceByHyphens(this.licensePlateCopy)

      if (!this.v$.licensePlateCopy.$invalid) {
        this.licensePlateCopy = this.clearHyphens(this.licensePlateCopy)
        this.licensePlateCopy = addSeparators(this.licensePlateCopy)
      }

      this.$emit('updateLicensePlate', this.licensePlateCopy, !this.v$.licensePlateCopy.$invalid)
    },
  },
}
</script>

<style lang="scss" scoped>
$license-yellow: #ffca00;
$license-blue: #2b6dac;

.license-plate-box {
  overflow: hidden;
  display: flex;
  box-shadow: 0 0 0 2px $license-yellow;
  border: 2px solid $text-color;
  border-radius: 0.5em;
  width: 14em;
}

.country-code {
  color: #fff;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  background: $license-blue;
  width: 15%;
}

svg {
  top: 0;
  display: block;
  height: 1.75em;
}

input {
  background: $license-yellow !important;
  box-shadow: none;
  border: 0;
  width: 85%;
  flex: 0 0 auto;
  margin: 0;
  padding: 0.25rem 0.25rem;
  font-family: Arial, Verdana, sans-serif;
  font-size: $font-size-base * 2;
  font-weight: $font-weight-bold;
  text-transform: uppercase;
  text-align: center;
  line-height: 1.1;
  color: $text-color;

  &:focus {
    outline: none;
    border: none;
  }
}
</style>
